import type { ChallengeInfo, MyChallenge, PlayerStats } from '@accra/shared';
import { api } from './apiClient';

export async function fetchChallenge(code: string): Promise<ChallengeInfo | null> {
  const result = await api<{ challenge: ChallengeInfo }>('GET', `/challenges/${code}`, null);
  return result?.ok ? result.challenge : null;
}

/** Turns a finished shift into a challenge link code. Null if it can't be shared. */
export async function createChallengeCode(key: string | null, runId: string): Promise<string | null> {
  if (!key) return null;
  const result = await api<{ code: string }>('POST', '/challenges', key, { runId });
  return result?.ok ? result.code : null;
}

export interface BadgeProgress {
  stats: PlayerStats & { cleanStreak: number };
  earned: { id: string; earnedAt: number }[];
}

export async function fetchBadges(key: string | null): Promise<BadgeProgress | null> {
  if (!key) return null;
  const result = await api<BadgeProgress>('GET', '/badges', key);
  return result?.ok ? { stats: result.stats, earned: result.earned } : null;
}

/** The challenges you've sent, and how many tries are new since you last looked. */
export async function fetchMyChallenges(key: string | null): Promise<{ challenges: MyChallenge[]; unseen: number } | null> {
  if (!key) return null;
  const result = await api<{ challenges: MyChallenge[]; unseen: number }>('GET', '/challenges/mine', key);
  return result?.ok ? { challenges: result.challenges, unseen: result.unseen } : null;
}

export async function markChallengesSeen(key: string | null): Promise<void> {
  if (key) await api('POST', '/challenges/mine/seen', key);
}
